import { createAction } from "@reduxjs/toolkit";
import { TalesParagraph } from "../../../utils/types/TalesParagraph";

export const setHighlightData =
  createAction<TalesParagraph[]>("highlight/setData");
